<footer class="footer" *ngIf="content">
  <app-footer-top [content]="content.top"></app-footer-top>
  <app-footer-content [content]="content.middle"></app-footer-content>
  <app-footer-products [content]="content.bottom"></app-footer-products>
</footer>
